module.exports = __webpack_public_path__ + "img/miaosha.3fcbae4d.png";